import { useSyncExternalStore } from 'react'

/**
 * How many px at the bottom of the layout viewport the person cannot see right now: a browser toolbar drawn over the
 * page (iOS Safari with viewport-fit=cover reports the whole 956 px screen as the viewport on an iPhone 16 Pro Max) or
 * an open keyboard. Bottom sheets sit above it, so their buttons are never under it (B-147, Alvin pin 580: Show results
 * off screen at 440 x 956). 0 where the browser has no visualViewport or nothing covers the page.
 */
function read(): number {
  const vv = typeof window !== 'undefined' ? window.visualViewport : null
  if (!vv) return 0
  // pinch zoom (scale > 1) moves the visual viewport around the page on purpose: nothing is covered then
  if (vv.scale > 1.01) return 0
  return Math.max(0, Math.round(window.innerHeight - (vv.height + vv.offsetTop)))
}

function subscribe(cb: () => void) {
  const vv = window.visualViewport
  if (!vv) return () => {}
  vv.addEventListener('resize', cb)
  vv.addEventListener('scroll', cb)
  window.addEventListener('resize', cb)
  return () => {
    vv.removeEventListener('resize', cb)
    vv.removeEventListener('scroll', cb)
    window.removeEventListener('resize', cb)
  }
}

export function useVisibleBottom(active = true): number {
  const v = useSyncExternalStore(subscribe, read, () => 0)
  return active ? v : 0
}
